import React, { useState } from "react";
import "./PasswordModal.css";

const PasswordModal = ({ onClose, onSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === "BERGER41") {
      setError("");
      onSuccess();
    } else {
      setError("Mot de passe incorrect");
      setPassword("");
    }
  };

  return (
    <div className="password-modal-overlay" onClick={onClose}>
      <div className="password-modal" onClick={(e) => e.stopPropagation()}>
        <div className="password-modal-header">
          <h2>🔒 Vue Administrateur</h2>
          <button className="password-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="password-modal-form">
          <div className="password-modal-group">
            <label htmlFor="password">Entrez le mot de passe :</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
              placeholder="Mot de passe"
              className="password-modal-input"
              autoFocus
            />
            {error && <div className="password-modal-error">{error}</div>}
          </div>
          
          <div className="password-modal-actions">
            <button type="button" className="password-modal-cancel" onClick={onClose}>
              Annuler
            </button>
            <button type="submit" className="password-modal-submit">
              Accéder
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordModal;

